import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signup-owf_main_signup_complete_store_profile_cta_with_fb_forwarding-click';
/**
 * Event fired when a successful response is received from user creation API &#x2F;api&#x2F;user&#x2F;sign-up&#x2F;post and sign up was via Open With Faire
 */
export function trackSignupOwfMainSignupCompleteStoreProfileCtaWithFbForwardingClick(pixelCustomDataParams) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        facebookPixelEvent: 'open-with-faire-signup',
        pixelCustomDataParams: pixelCustomDataParams,
    });
}
